import React, { useEffect } from 'react';
import gettext from '@eb/gettext';
import { setWindowLocation } from '@eb/http';

import { LinkChunky } from '@eb/eds-iconography';
import { AlertChunky } from '@eb/eds-iconography';

import LinkedAccountsGreyDialog from './LinkedAccountsGrayDialog';

import {
    BASE_URL,
    SET_LINK_ACCOUNT_OK,
    SET_LINK_ACCOUNT_ERROR,
    SET_LINK_ACCOUNT_TOKEN_EXPIRED,
    SET_LINK_ACCOUNT_OTHER_ERROR,
} from '../constants';

const getStrings = ({ status, isLoading }) => {
    let iconType = null;
    let headerText = gettext('Please wait while we link your accounts');
    let subtitleTextDark = '';
    let subtitleText = '';
    let buttonText = '';
    let buttonRedirection = null;

    if (!isLoading) {
        iconType = <LinkChunky />;
        headerText = gettext('Your social account is now linked!');
        subtitleTextDark = gettext(
            'You can now login to Eventbrite using your social account.',
        );
        subtitleText = gettext(
            'You may unlink your account anytime under your Linked account settings.',
        );
        buttonText = gettext('Continue');
        buttonRedirection = '/';
    }

    // For the time beign all the texts for the failed status are placeholders, once we have the official copies these should be changed
    if (status === SET_LINK_ACCOUNT_ERROR) {
        iconType = <AlertChunky />;
        headerText = gettext(
            'Something went wrong trying to link your account!',
        );
        subtitleTextDark = gettext('Please try again in a few minutes');
        subtitleText = gettext(
            'If the issue persists please contact technical support',
        );
        buttonText = gettext('Close');
        buttonRedirection = BASE_URL;
    }

    if (status === SET_LINK_ACCOUNT_TOKEN_EXPIRED) {
        iconType = <AlertChunky />;
        headerText = gettext('Your link has expired!');
        subtitleTextDark = gettext(
            'Please try again, and we will send you a new link.',
        );
        subtitleText = gettext('Remember the link will expire in 2 hours.');
        buttonText = gettext('Close');
        buttonRedirection = BASE_URL;
    }

    if (status === SET_LINK_ACCOUNT_OTHER_ERROR) {
        iconType = <AlertChunky />;
        headerText = gettext(
            'You are logged in but something went wrong trying to link your account!',
        );
        subtitleTextDark = gettext(
            'Please try to link your account manually in user settings',
        );
        subtitleText = gettext(
            'If the issue persists please contact technical support. ',
        );
        buttonText = gettext('Continue');
        buttonRedirection = '/';
    }

    const strings = {
        iconType,
        headerText,
        subtitleTextDark,
        subtitleText,
        buttonText,
        buttonRedirection,
    };

    return strings;
};

const AccountLinkMessage = ({
    status = SET_LINK_ACCOUNT_OK,
    isLoading,
    onCloseButtonClick,
}) => {
    const {
        iconType,
        headerText,
        subtitleText,
        subtitleTextDark,
        buttonText,
        buttonRedirection,
    } = getStrings({ status, isLoading });

    const _handleOnClick = () => {
        if (onCloseButtonClick) {
            onCloseButtonClick(status);
        }

        setWindowLocation(buttonRedirection);
    };

    useEffect(() => {
        if (!isLoading) {
            const timer = setTimeout(() => _handleOnClick(), 5000);

            return function cleanup() {
                clearTimeout(timer);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    return (
        <LinkedAccountsGreyDialog
            iconType={iconType}
            headerText={headerText}
            subtitleTextDark={subtitleTextDark}
            subtitleText={subtitleText}
            buttonText={buttonText}
            handleOnClick={_handleOnClick}
            isLoading={isLoading}
        />
    );
};

export default AccountLinkMessage;
